/* Tonochi: email forms for back in stock (product pages, routine page) and coming soon alerts (routine page).
   A form with data-tn-notify and data-variant subscribes the email to Klaviyo back in stock for that Shopify variant.
   A form with data-list (and data-interest) subscribes the email to that Klaviyo list and records which step it was for.
   The emails themselves are sent by the Klaviyo flow "Back In Stock Flow - Standard" (and a campaign for coming soon). */
(() => {
  if (window.tnNotifyReady) return;
  window.tnNotifyReady = true;
  const COMPANY = 'ULhP5J';
  const REVISION = '2024-10-15';
  const post = (path, body) => fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: REVISION },
    body: JSON.stringify(body)
  }).then((r) => { if (!r.ok) throw new Error(String(r.status)); });
  const profile = (email) => ({ data: { type: 'profile', attributes: { email } } });

  function backInStock(email, variantId) {
    return post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { profile: profile(email), channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    });
  }
  function comingSoon(email, listId, interest) {
    return Promise.all([
      post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: { custom_source: 'Routine page: ' + interest, profile: profile(email) },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      }),
      post('events', {
        data: {
          type: 'event',
          attributes: {
            properties: { Step: interest, Page: location.pathname },
            metric: { data: { type: 'metric', attributes: { name: 'Coming soon alert signup' } } },
            profile: profile(email)
          }
        }
      }).catch(() => {})
    ]);
  }
  window.tnNotify = { backInStock, comingSoon };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-tn-notify]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    const msg = form.querySelector('[data-msg]');
    const btn = form.querySelector('button[type="submit"]');
    const email = (input.value || '').trim();
    const show = (text, ok) => { msg.textContent = text; msg.hidden = false; msg.classList.toggle('is-error', !ok); };
    if (!email || !input.checkValidity() || !email.split('@')[1]?.includes('.')) { show('Please enter a valid email address.', false); input.focus(); return; }
    btn.disabled = true;
    const job = form.dataset.list ? comingSoon(email, form.dataset.list, form.dataset.interest || '') : backInStock(email, form.dataset.variant);
    job.then(() => {
      form.classList.add('is-done');
      show(form.dataset.list ? 'Thank you! We’ll email you when it launches.' : 'Thank you! We’ll email you as soon as it’s back in stock.', true);
    }).catch(() => {
      show('Something went wrong. Please try again.', false);
    }).finally(() => { btn.disabled = false; });
  });
})();
